import { apiSlice } from "../api/apiSlice";

export const uploadFileApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    uploadFile: builder.mutation({
      query: (data) => {
        return {
          url: "/upload/trial-results",
          method: "POST",
          body: data,
          formData: true,
        };
      },
      transformResponse: (result) => {
        return result;
      },
    }),
  }),
});

export const { useUploadFileMutation } = uploadFileApiSlice;
